import { AnimationBaseController, IAnimationControllerConfiguration, Inject, IBaseController } from "@denishussar/html5-game-engine";
import { FieldTypeConstants } from "../../Constants/FieldTypeConstants";
import { IFieldSize } from "../../Constants/FieldSizesConstants";
import { KykkaState } from "../../Constants/KykaState";
import { KykkaModel } from "../../Models/KykkaModel";
import { GameModel } from "../../Models/GameModel";
import { AnimationContents } from "../AnimationContents";
import { KykkaItemController } from "./KykkaItemController";
import { PlayerTurnConstant } from "../../Constants/PlayerTurnConstant";

export class KyykasContainerController extends AnimationBaseController {
    $model: GameModel

    private _kykkaItemsA: IBaseController[] = [];
    private _kykkaItemsB: IBaseController[] = [];

    public constructor(@Inject private _options: any) {
        super("KyykasContainerController");
        console.log('KyykasContainerController', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            modelWatch: {
                kykkaItems: (items) => {
                    this._castKykkasA();
                },
                kykkaItemsB: (items) => {
                    this._castKykkasB();
                },
                currentTurn: (currentTurn) => this._setPositionByTurn(currentTurn),
                isGameReady: (ready: boolean) => {
                    if (ready) {
                        this._setPositionByTurn(this.$model.currentTurn);
                    }
                },
                isFreeField: (isFreeField: boolean) => {
                    if (isFreeField) {
                        this._removeItems(this._kykkaItemsA);
                        this._removeItems(this._kykkaItemsB);
                    }
                },
            },
        }
    }

    protected onInitialize(): void {
        this._castKykkasA();
        this._castKykkasB();
        this._setPositionByTurn(this.$model.currentTurn);
    }

    private _spanItem(kykkaModelItems: KykkaModel[], type: 'a' | 'b') {
        if (type === 'b') {
            console.log('==> b');

        }
        const list = kykkaModelItems.map((item, i) => {
            return this.addChildController({
                animationContent: AnimationContents.TABLO_SCREEN_JSON,
                libraryName: "kykka_item",
                view: KykkaItemController,
                model: item,
                options: {
                    fieldType: this.$model.fieldType,
                    fieldSize: this.$model.fieldSize
                }
            }, `kykka_item_${type}_${i}`);
        });

        return list;
    }


    private _removeItems(list: IBaseController[]) {
        while (list.length) {
            this.removeChildController(list.pop());
        }
    }

    private _setPositionByTurn(turn: PlayerTurnConstant) {
        if(turn === PlayerTurnConstant.A) {
            this.rotation = 0;
            this.y = 721;
        } else {
            this.rotation = Math.PI;
            this.y =  1287;
        }
    }

    private _castKykkasA() {
        this._removeItems(this._kykkaItemsA);
        this._kykkaItemsA = this._spanItem(this.$model.kykkaItems, 'a');
    }

    private _castKykkasB() {
        this._removeItems(this._kykkaItemsB);
        this._kykkaItemsB = this._spanItem(this.$model.kykkaItemsB, 'b');
    }

}